/* eslint-disable prefer-const */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-else-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unused-state */
/* eslint-disable object-shorthand */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/no-string-refs */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";
import ReactTable from "react-table"
import moment from "moment";
import "font-awesome/css/font-awesome.min.css";
import "react-table/react-table.css"
import { managerTeamAPI } from "../../../services/userReceivedAPI";
import { filterByMonths } from "../../../services/managerDashboardFunctions";
import "./DashboardManager.css";
import ExportPic from "../../../images/1.svg";

import {
  DashboardManagerPageWrapper,
  DashboardRowOneWrapper,
  SentReceivedBoxWrapper,
  BoxContainer,
  SentReceivedContainer,
  ReceivedContainer,
  SentReceivedTitleWrapper,
  ExportTitleWrapper,
  GraphWrapper,
  GraphInlineWrapper,
  TableWrapper,
  OverviewWrapper,
  HistoryWrapper,
  SentRecTabContainer,
  DashboardUserBanner,
  HighFiveLockup,
  UserTabContainer,
  UserBannerTopWrapper,
  GraphBannerWrapper,
  DropDownBoxWrapper,
  FilterWrapper,
  FlyoutWrapper,
  FlyoutInsideWrapper,
  FlyoutWrapperOptions,
} from "./DashboardManager.style";

class DashboardPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
          filtered: [],
          select2: undefined,
          isSent: false,
          tableJson: [{}],
          originalJson: [{}],
          json: [{}],
          name: props.user.name,
          recieved:"0",
          sent:"0",
          recMaxim:{
            one:"",
            two:"",
            three:"",
            four:"",
            five:""
          },
          sentMaxim:{
            one:"",
            two:"",
            three:"",
            four:"",
            five:""
          },
          dateFiltered: "12 Months",
          receivedColumns: [
            {
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >To
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="sel sel--black-panther">
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%",
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getRec().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "recipient",
              sortable: true,
              headerStyle: {
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: { whiteSpace: "unset" },
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >From
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="select_box">
                    <select
                      onChange={event => onChange(
                        event.target.value
                        )}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%",
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getSend().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "sender",
              sortable: true,
              headerStyle: {
                width: "400px",
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: {
                whiteSpace: "unset",
             },
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Maxim
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="select_box">
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%",
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getMax().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "maxim",
              width: 250,
              sortable: true,
              headerStyle: {
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: { whiteSpace: "unset" },
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Message
                </div>
              ),
              accessor: "message",
              width: 550,
              sortable: false,
              filterable: false,
              headerStyle: {
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: { whiteSpace: "unset" },
            },{
              id: "date",
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Date
                </div>
              ),
              width: 100,
              sortable: false,
              filterable: false,
              accessor: dates => moment(dates.date).format("MMM DD YYYY"),
              headerStyle: {
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: { whiteSpace: "unset" },
            },
          ],
          sentColumns: [
            {
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >From
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="select_box">
                    <select
                      onChange={event => onChange(
                        event.target.value
                        )}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%",
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getSend().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "sender",
              sortable: true,
              headerStyle: {
                width: "400px",
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: {
                whiteSpace: "unset",
             },
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >To
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="select_box">
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%",
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getRec().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "recipient",
              sortable: true,
              headerStyle: {
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: { whiteSpace: "unset" },
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Maxim
                </div>
              ),
              filterMethod: (filter, row) => {
                return row[filter.id] === filter.value;
              },
              Filter: ({ filter, onChange }) =>
                (
                  <div className="select_box">
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{
                        fontFamily: "HelveticaNeue",
                        fontWeight: "bold",
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        height: "40px",
                        background: "transparent",
                        width: "100%",
                      }}
                      value={filter ? filter.value : "all"}
                    >
                      <option value="">All</option>
                      {this.getMax().map((option, id) => (
                        <option key={id} value={option}>
                          {option}
                        </option>
                        ))}
                    </select>
                  </div>
                ),
              accessor: "maxim",
              width: 250,
              sortable: true,
              headerStyle: {
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: { whiteSpace: "unset" },
            },{
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Message
                </div>
              ),
              accessor: "message",
              width: 550,
              sortable: false,
              filterable: false,
              headerStyle: {
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: { whiteSpace: "unset" },
            },{
              id: "date",
              Header: () => (
                <div
                  style={{
                    paddingLeft: "10px",
                    textAlign:"left"
                  }}
                >Date
                </div>
              ),
              width: 100,
              sortable: false,
              filterable: false,
              accessor: dates => moment(dates.date).format("MMM DD YYYY"),
              headerStyle: {
                height: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "HelveticaNeue-Medium",
                fontSize: "16px"
              },
              style: { whiteSpace: "unset" },
            },
          ]
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.filterByOneYear = this.filterByOneYear.bind(this);
        this.changeStateJsonToReceived = this.changeStateJsonToReceived.bind(this);
        this.changeStateJsonToSent = this.changeStateJsonToSent.bind(this);
        this.getSend = this.getSend.bind(this);
        this.getRec = this.getRec.bind(this);
        this.getMax = this.getMax.bind(this);
        this.onFilteredChangeCustom = this.onFilteredChangeCustom.bind(this);
    }

    async componentDidMount(){
      try{
        const that = this;
        const data = await managerTeamAPI()
        that.setState({
          recieved: data.message[2].stats[0].overallReceived,
          sent: data.message[2].stats[0].overallSent,
          recMaxim: window.sessionStorage.company === 'nike' ? {
            one: data.message[2].stats[0].receivedMaximServeAthletes,
            two: data.message[2].stats[0].receivedMaximCreateTheFutureOfSport,
            three: data.message[2].stats[0].receivedMaximBeOnTheOffenseAlways,
            four: data.message[2].stats[0].receivedMaximDoTheRightThing,
            five: data.message[2].stats[0].receivedMaximWinAsATeam
          } : {
            one: data.message[2].stats[0].receivedValuesServeYouth,
            two: data.message[2].stats[0].receivedValuesSparkProgress,
            three: data.message[2].stats[0].receivedValuesDareGreatly,
            four: data.message[2].stats[0].receivedValuesDoTheRightThing,
            five: data.message[2].stats[0].receivedValuesWinTogether
          },
          sentMaxim: window.sessionStorage.company === 'nike' ? {
            one: data.message[2].stats[0].sentMaximServeAthletes,
            two: data.message[2].stats[0].sentMaximCreateTheFutureOfSport,
            three: data.message[2].stats[0].sentMaximBeOnTheOffenseAlways,
            four: data.message[2].stats[0].sentMaximDoTheRightThing,
            five: data.message[2].stats[0].sentMaximWinAsATeam
          } : {
            one: data.message[2].stats[0].sentValuesServeYouth,
            two: data.message[2].stats[0].sentValuesSparkProgress,
            three: data.message[2].stats[0].sentValuesDareGreatly,
            four: data.message[2].stats[0].sentValuesDoTheRightThing,
            five: data.message[2].stats[0].sentValuesWinTogether
          },
          originalJson: data.message,
          tableJson: data.message,
          json: data.message[0].sent,
        })
      } catch (err) {
        logger.log(`Error Fetching Data From DB: ${err}`);
      }
    }

    onFilteredChangeCustom = (value, accessor) => {
      let filtered = this.state.filtered;
      let insertNewFilter = 1;

      if (filtered.length) {
        filtered.forEach((filter, index) => {
          if (filter.id === accessor) {
            if (value === "" || !value.length) filtered.splice(index, 1);
            else filter.value = value;

            insertNewFilter = 0;
          }
        });
      }

      if (insertNewFilter) {
        filtered.push({ id: accessor, value: value });
      }

      this.setState({ filtered: filtered });
    };

    getSend = () => {
      const addedArray = [];
      let optionSend = this.state.json.map((optionData) => {
        if(!addedArray.includes(optionData.sender)){
          addedArray.push(optionData.sender)
          return optionData.sender;
        }
      })
      optionSend = optionSend.filter(Boolean);
      return optionSend
    };

    getRec = () => {
      const addedArray = [];
      let optionRec = this.state.json.map((optionData) => {
        if(!addedArray.includes(optionData.recipient)){
          addedArray.push(optionData.recipient)
          return optionData.recipient;
        }
      })
      optionRec = optionRec.filter(Boolean);
      return optionRec
    };

    getMax = () => {
      const addedArray = [];
      let optionMax = this.state.json.map((optionData) => {
        if(!addedArray.includes(optionData.maxim)){
          addedArray.push(optionData.maxim)
          return optionData.maxim;
        }
      })
      optionMax = optionMax.filter(Boolean);
      return optionMax
    };

    handleExportClick(evt) {
      evt.preventDefault();
      window.fetch(process.env.REACT_APP_SUBMISSION_MANAGER_EXPORT_API, {
          headers: {
              Authorization: `Bearer ${window.sessionStorage.accessToken}`,
          },
      })
          .then((response) => {
              if (!response.ok) {
                  throw new Error("Export error");
              }
              return response.blob();
          }).then((blob) => {
              const objectURL = window.URL.createObjectURL(blob);
              window.location = objectURL;
          }).catch((err) => {
              console.log(err);
          });
    }

    changeStateJsonToSent(){
      this.setState({
        isSent: false,
        json: this.state.tableJson[0].sent
      })
    }

    changeStateJsonToReceived(){
      this.setState({
        isSent: true,
        json: this.state.tableJson[1].received
      })
    }

    async applyFilter( months ){
      const response = await filterByMonths(months, this.state.originalJson);
      console.log(this.state.originalJson)
      this.setState({
        recieved: response[0].overallRec,
        sent: response[0].overallSent,
        recMaxim: window.sessionStorage.company === 'nike' ? {
          one: response[0].receivedMaximServeAthletes,
          two: response[0].receivedMaximCreateTheFutureOfSport,
          three: response[0].receivedMaximBeOnTheOffenseAlways,
          four: response[0].receivedMaximDoTheRightThing,
          five: response[0].receivedMaximWinAsATeam,
        } : {
          one: response[0].receivedValuesServeYouth,
          two: response[0].receivedValuesSparkProgress,
          three: response[0].receivedValuesDareGreatly,
          four: response[0].receivedValuesDoTheRightThing,
          five: response[0].receivedValuesWinTogether,
        },
        sentMaxim: window.sessionStorage.company === 'nike' ? {
          one: response[0].sentMaximServeAthletes,
          two: response[0].sentMaximCreateTheFutureOfSport,
          three: response[0].sentMaximBeOnTheOffenseAlways,
          four: response[0].sentMaximDoTheRightThing,
          five: response[0].sentMaximWinAsATeam,
        } : {
          one: response[0].sentValuesDareGreatly,
          two: response[0].sentValuesDoTheRightThing,
          three: response[0].sentValuesServeYouth,
          four: response[0].sentValuesSparkProgress,
          five: response[0].sentValuesWinTogether,
        },
        dateFiltered: `${months} Months`,
        tableJson: response[0].finalmonthSubmissions,
        json: response[0].finalmonthSubmissions[0].sent
      })
    }

    async filterByOneYear(){
      // api returns last One year data - this.state.originalJson
      this.setState({
        recieved: this.state.originalJson[2].stats[0].overallReceived,
        sent: this.state.originalJson[2].stats[0].overallSent,
        recMaxim: window.sessionStorage.company === 'nike' ? {
          one: this.state.originalJson[2].stats[0].receivedMaximServeAthletes,
          two: this.state.originalJson[2].stats[0].receivedMaximCreateTheFutureOfSport,
          three: this.state.originalJson[2].stats[0].receivedMaximBeOnTheOffenseAlways,
          four: this.state.originalJson[2].stats[0].receivedMaximDoTheRightThing,
          five: this.state.originalJson[2].stats[0].receivedMaximWinAsATeam,
        } : {
          one: this.state.originalJson[2].stats[0].receivedValuesServeYouth,
          two: this.state.originalJson[2].stats[0].receivedValuesSparkProgress,
          three: this.state.originalJson[2].stats[0].receivedValuesDareGreatly,
          four: this.state.originalJson[2].stats[0].receivedValuesDoTheRightThing,
          five: this.state.originalJson[2].stats[0].receivedValuesWinTogether,
        },
        sentMaxim: window.sessionStorage.company === 'nike' ? {
          one: this.state.originalJson[2].stats[0].sentMaximServeAthletes,
          two: this.state.originalJson[2].stats[0].sentMaximCreateTheFutureOfSport,
          three: this.state.originalJson[2].stats[0].sentMaximBeOnTheOffenseAlways,
          four: this.state.originalJson[2].stats[0].sentMaximDoTheRightThing,
          five: this.state.originalJson[2].stats[0].sentMaximWinAsATeam,
        } : {
          one: this.state.originalJson[2].stats[0].sentValuesServeYouth,
          two: this.state.originalJson[2].stats[0].sentValuesSparkProgress,
          three: this.state.originalJson[2].stats[0].sentValuesDareGreatly,
          four: this.state.originalJson[2].stats[0].sentValuesDoTheRightThing,
          five: this.state.originalJson[2].stats[0].sentValuesWinTogether,
        },
        originalJson: this.state.originalJson,
        tableJson: this.state.originalJson,
        json: this.state.originalJson[0].sent,
      })
    }

    render() {
      const data = window.sessionStorage.company === 'nike' ?
      [
        {name: "Serve Athletes*", Received: this.state.recMaxim.one, Sent: this.state.sentMaxim.one, },
        {name: "Create the Future of Sport", Received: this.state.recMaxim.two, Sent: this.state.sentMaxim.two,},
        {name: "Be on the Offense Always", Received: this.state.recMaxim.three, Sent: this.state.sentMaxim.three,},
        {name: "Do the Right Thing", Received: this.state.recMaxim.four, Sent: this.state.sentMaxim.four,},
        {name: "Win as a Team", Received: this.state.recMaxim.five, Sent: this.state.sentMaxim.five,}
      ] : [
        {name: "Serve Youth", Received: this.state.recMaxim.one, Sent: this.state.sentMaxim.one, },
        {name: "Spark Progress", Received: this.state.recMaxim.two, Sent: this.state.sentMaxim.two,},
        {name: "Dare Greatly", Received: this.state.recMaxim.three, Sent: this.state.sentMaxim.three,},
        {name: "Do the Right Thing", Received: this.state.recMaxim.four, Sent: this.state.sentMaxim.four,},
        {name: "Win Together", Received: this.state.recMaxim.five, Sent: this.state.sentMaxim.five,},
      ];

        return (
          <DashboardManagerPageWrapper>
            <UserBannerTopWrapper>
              <DashboardUserBanner>
                <HighFiveLockup />
                <UserTabContainer>
                  <a
                    id="Send a High Five"
                    title="See your High Fives"
                    href={`${window.location.origin  }/dashboard`}
                    style={{
                      fontFamily: "HelveticaNeue-Medium",
                      fontSize: "16px",
                      paddingRight: "5px",
                      color: "#8d8d8d",
                      height: "48px"
                    }}
                  >
                    { this.state.name }
                  </a>
                  <a
                    id="Go to Dashboard"
                    title="See your Team High Fives"
                    href={`${window.location.origin  }/manager-dashboard`}
                    style={{
                      fontFamily: "HelveticaNeue-Medium",
                      fontSize: "16px",
                      paddingLeft: "5px",
                      color: null,
                      height: "48px",
                    }}
                  >
                  My Team
                  </a>
                  <a
                    id="Go to Dashboard"
                    title="Send A High Five"
                    href={`${`${window.location.origin  }/submit`}#submitForm"`}
                    style={{
                      background: "#061b38",
                      color: "#ffffff",
                      padding: "1em 4em",
                      margin: "1em",
                      display: "inline-block",
                      borderRadius: "5em",
                      fontSize: "16px",
                      fontWeight: "bold",
                      lineHeight: "20px",
                    }}
                  >
                  Send A High Five
                  </a>
                </UserTabContainer>
              </DashboardUserBanner>
            </UserBannerTopWrapper>
            <DashboardRowOneWrapper>
              <GraphBannerWrapper>
                <GraphBannerWrapper>
                  Team Overview
                </GraphBannerWrapper>
                <DropDownBoxWrapper>
                  <FilterWrapper>
                    <FlyoutWrapper>
                      <FlyoutInsideWrapper>
                        { this.state.dateFiltered }
                      </FlyoutInsideWrapper>
                      <FlyoutWrapperOptions>
                        <button
                          className="ncss-option ncss-brand pt2-sm pr5-sm pb2-sm pl5-sm"
                          onClick={this.filterByOneYear}
                          style={{
                            outline: "none",
                          }}
                        >
                          12 Months
                        </button>
                        <button
                          className="ncss-option ncss-brand pt2-sm pr5-sm pb2-sm pl5-sm"
                          onClick={()=> this.applyFilter(6)}
                          style={{
                            outline: "none",
                          }}
                        >
                          6 Months
                        </button>
                        <button
                          className="ncss-option ncss-brand pt2-sm pr5-sm pb2-sm pl5-sm"
                          onClick={()=> this.applyFilter(3)}
                          style={{
                            outline: "none",
                          }}
                        >
                          3 Months
                        </button>
                        <button
                          className="ncss-option ncss-brand pt2-sm pr5-sm pb2-sm pl5-sm"
                          onClick={()=> this.applyFilter(1)}
                          style={{
                            outline: "none",
                          }}
                        >
                          1 Month
                        </button>
                      </FlyoutWrapperOptions>
                    </FlyoutWrapper>
                  </FilterWrapper>
                </DropDownBoxWrapper>
              </GraphBannerWrapper>
            </DashboardRowOneWrapper>
            <DashboardRowOneWrapper>
              <GraphWrapper>
                <GraphInlineWrapper>
                  <ResponsiveContainer >
                    <BarChart
                      data={data}
                      margin={{top: 20, right: -75, left: -25, bottom: 25}}
                    >
                      <CartesianGrid strokeOpacity="0" fillOpacity="100" fill="#f4f4f4" />
                      <XAxis
                        dy={8}
                        stroke="#111111"
                        dataKey="name"
                        interval={0}
                        axisLine={false}
                        tickLine={false}
                        tick={{
                          fontWeight: 500,
                          fontSize: 12,
                          letterSpacing:0.3,
                          fontFamily: "Helvetica Neue",
                          width: 150,
                          textAnchor:"middle",
                          verticalAnchor:"start",
                        }}
                      />
                      <YAxis
                        axisLine={false}
                        tickLine={false}
                      />
                      <Legend
                        iconType="circle"
                        layout="vertical"
                        verticalAlign="top"
                        align="right"
                        wrapperStyle={{ marginRight:"100px", marginTop:"30px", floating:true }}
                      />
                      <Tooltip />
                      <Bar dataKey="Sent" fill="#6D6D6D" />
                      <Bar dataKey="Received" fill="#061b38" />
                    </BarChart>
                  </ResponsiveContainer>
                </GraphInlineWrapper>
              </GraphWrapper>
              <SentReceivedBoxWrapper>
                <BoxContainer>
                  <SentReceivedContainer className="border-right-white">
                    {this.state.sent}
                  </SentReceivedContainer>
                  <ReceivedContainer className="outline">
                    {this.state.recieved}
                  </ReceivedContainer>
                  <SentReceivedTitleWrapper className="border-right-white">
                    Sent
                  </SentReceivedTitleWrapper>
                  <SentReceivedTitleWrapper>
                    Received
                  </SentReceivedTitleWrapper>
                  <ExportTitleWrapper color="#FFFFF">
                    <a
                      onClick={this.handleExportClick}
                      href={process.env.REACT_APP_SUBMISSION_EXPORT_API}
                      className="ncss-brand
                      pt2-sm pr5-sm pb2-sm pl6-sm va-sm-b d-sm-ib"
                    >
                      <h1 style={{color:"white"}} className="va-sm-m d-sm-ib">
                        Export CSV
                      </h1>
                      <img src={ExportPic} alt="" className="va-sm-m d-sm-ib" />
                    </a>
                  </ExportTitleWrapper>
                  <SentReceivedTitleWrapper style={{
                    marginBottom: "232px"
                  }}
                  >
                    {}
                  </SentReceivedTitleWrapper>
                </BoxContainer>
              </SentReceivedBoxWrapper>
            </DashboardRowOneWrapper>
            <OverviewWrapper>
              <HistoryWrapper>
                History
              </HistoryWrapper>
              <SentRecTabContainer>
                <button
                  onClick={this.changeStateJsonToSent}
                  title="Sent High Fives"
                  style={{
                    outline: "0",
                    fontFamily: "HelveticaNeue-Medium",
                    fontWeight: "500px",
                    backgroundColor: "transparent",
                    borderBottom: !this.state.isSent ? "2px solid #061B38" : null,
                    color: null,
                    height: "48px"
                  }}
                >
                  Sent
                </button>
                <button
                  onClick={this.changeStateJsonToReceived}
                  title="Received High Fives"
                  style={{
                    outline: "0",
                    fontFamily: "HelveticaNeue-Medium",
                    fontWeight: "500px",
                    backgroundColor: "transparent",
                    borderBottom: this.state.isSent ? "2px solid #061B38" : null,
                    color: null,
                    height: "48px"
                  }}
                >
                  Received
                </button>
              </SentRecTabContainer>
            </OverviewWrapper>
            <TableWrapper>
              <ReactTable
                ref="reactTable"
                noDataText={this.state.isSent ? "No Received High Fives" : "No Sent High Fives"}
                className="-striped -highlight"
                minRows={0}
                filterable
                style={{
                  height: "728px" // This will force the table body to overflow and scroll, since there is not enough room
                }}
                filtered={this.state.filtered}
                onFilteredChange={(filtered, column, value) => {
                  this.onFilteredChangeCustom(value, column.id || column.accessor);
                }}
                defaultFilterMethod={(filter, row) => {
                  const id = filter.pivotId || filter.id;
                  if (typeof filter.value === "object") {
                    return row[id] !== undefined
                      ? filter.value.indexOf(row[id]) > -1
                      : true;
                  } else {
                    return row[id] !== undefined
                      ? String(row[id]).indexOf(filter.value) > -1
                      : true;
                  }
                }}
                defaultPageSize={25}
                data={this.state.json}
                columns={this.state.isSent ? this.state.receivedColumns : this.state.sentColumns}
              />
            </TableWrapper>
          </DashboardManagerPageWrapper>
         );
    }
}

DashboardPage.propTypes = {
    user: PropTypes.object,
}

DashboardPage.defaultProps = {
    user: {}
}

export default DashboardPage;


// WEBPACK FOOTER //
// ./src/containers/DashboardPage/DashboardManager/DashboardManagerPage.js